import { ScatterChart, Scatter, XAxis, YAxis, ResponsiveContainer } from "recharts";

const DEFAULT_DOMAIN = ["auto", "auto"];

export function GanttChart({
  data,
  dataNormalizer,
  xAxisKey,
  xAxisType,
  yAxisKey,
  yAxisType,
  shape,
  domain = DEFAULT_DOMAIN,
  tick = undefined,
  tickFormatter = undefined,
  tickCount = 50,
  backgroundComponents = [],
  foregroundComponents = [],
}) {
  const normalizedData = dataNormalizer(data);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart
        margin={{
          top: 0,
          right: 20,
          bottom: 20,
          left: 40,
        }}
      >
        {backgroundComponents}
        <XAxis
          domain={domain}
          dataKey={xAxisKey}
          type={xAxisType}
          tick={tick}
          tickCount={tickCount}
          tickFormatter={tickFormatter}
          tickMargin={15}
        />
        <YAxis dataKey={yAxisKey} type={yAxisType} hide />
        <Scatter data={normalizedData} shape={shape} />
        {foregroundComponents}
      </ScatterChart>
    </ResponsiveContainer>
  );
}
